const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof market_share_intelligence !== "undefined") return resolve();
	__webpack_require__.l("/assets/market-share-intelligence/remote.js", (event) => {
		if(typeof market_share_intelligence !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "market_share_intelligence");
}).then(() => (market_share_intelligence));